import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'yes-no-dropdown',
  template: `
    <select class="settings-value"  [(ngModel)]="value" (change)="onValueChanged($event)">
      <option [ngValue]="true">{{yesCaption}}</option>
      <option [ngValue]="false">{{noCaption}}</option>
    </select>
  `
})
export class YesNoDropdownComponent implements OnInit {
  @Input() value: boolean;
  @Output() valueChange = new EventEmitter();

  @Input() yesCaption?: string;
  @Input() noCaption?: string;

  ngOnInit(): void {
    this.yesCaption = this.yesCaption || 'Yes';
    this.noCaption = this.noCaption || 'No';
  }

  onValueChanged(event: any) {
    this.valueChange.emit(this.value);
  }
}
